__turbopack_context__.v({
  "className": "amiri_9595f4dd-module__gYucKG__className",
  "variable": "amiri_9595f4dd-module__gYucKG__variable",
});
